import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import _ from 'lodash';
import humanizeDuration from 'humanize-duration';
import moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-online-experience-schedule',
  templateUrl: './online-experience-schedule.component.html',
  styleUrls: ['./online-experience-schedule.component.css']
})
export class OnlineExperienceScheduleComponent implements OnInit {

  @Input() experienceForm: DVFormGroup;

  onlineDetailsForm: DVFormGroup;

  durations = _.range(1, 11).map(v => ({
    display: humanizeDuration(v * 30 * 60 * 1000, {
      units: ['h', 'm']
    }),
    value: v * 30
  }));

  sessionsPerDay = _.range(1, 6);

  daysOfWeek = moment.weekdays().map((week, i) => ({
    value: i,
    display: week
  }));

  multiSelectSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'display',
    allowSearchFilter: false,
  };
  constructor() { }

  ngOnInit() {
    this.onlineDetailsForm = this.experienceForm.controls.OnlineExperienceDetails as DVFormGroup;
  }

}
